<template>
  <div>
    <div class="banner">
      <Head></Head>
      <div class="topT">
        <div class="leftC">
          <div class="bTitle">码客查APP</div>
          <div class="sTitle">经营者专属管理APP-团队业绩、排行、客户跟进情况一目了然</div>
          <div class="tyBtn">立即体验</div>
        </div>
        <div class="rightImg"></div>
      </div>
    </div>
    <div class="model">
        <div class="name">码客查APP</div>
        <img class="model1" src="../../assets/images/model1@2x.png" alt="" srcset="">
        <img class="model2" src="../../assets/images/model2@2x.png" alt="" srcset="">
        <img class="model3" src="../../assets/images/model3@2x.png" alt="" srcset="">
    </div>
    <BNavigation></BNavigation>
  </div>
</template>

<script>
  import Head from './Head'
  import BNavigation from './bNavigation'
  export default {
    data() {
      return {
        bottleneckList: [{
          title: '品牌信任难',
          content: '缺乏背书，难以打造品牌信任感',
          img: require('../../assets/images/pinp@2x.png'),
        }, {
          title: '行业竞争大',
          content: '经济环境影响行业发展内卷',
          img: require('../../assets/images/hy@2x.png'),
        }, {
          title: '数据收集难',
          content: '沟通过程无监管复盘分析难',
          img: require('../../assets/images/sj@2x.png'),
        }, {
          title: '平台流量贵',
          content: '获客成本高，线索流失大',
          img: require('../../assets/images/ptll@2x.png'),
        }, {
          title: '获客留存难',
          content: '用户画像模糊，留存转化低',
          img: require('../../assets/images/hk@2x.png'),
        }]
      }
    },
    components: {
      Head,
      BNavigation
    },
  }
</script>

<style scoped>
  @media (max-width: 1500px) {
    .bottleneck{
      width: 1440px;
    }
  }

  @media (min-width: 1500px) {
    .bottleneck{
      width: 1640px;
    }
  }

  .banner {
    width: 100%;
    height: 620px;
    background: url('../../assets/images/scrm_bg@2x.png') top center no-repeat;
    background-size: 100% 100%;
  }

  .topT {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 100px;
    box-sizing: border-box;
  }

  .leftC {
    width: 524px;
    margin-right: 183px;
  }

  .bTitle {
    font-size: 42px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1E232A;
    line-height: 70px;
    letter-spacing: 1px;
  }

  .sTitle {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1E232A;
    line-height: 36px;
    margin: 27px 0 63px;
  }

  .tyBtn {
    width: 154px;
    height: 52px;
    background: linear-gradient(270deg, #14E1A0 0%, #02B4E0 100%);
    border-radius: 26px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rightImg {
    width: 465px;
    height: 490px;
    background: url('../../assets/images/app_sc@2x.png') top center no-repeat;
    background-size: 100% 100%;
  }

  .model {
    width: 100%;
    height: 985px;
    background: url('../../assets/images/modelBg@2x.png') top center no-repeat;
    background-size: cover;
    box-sizing: border-box;
    padding-top: 110px;
    position: relative;
    display: flex;
    justify-content: center;
  }

  .model .name {
    font-size: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1F2329;
    line-height: 40px;
    text-align: center;
  }

  .model1 {
    width: 455px;
    height: 205px;
    position: absolute;
    top: 40%;
    left: 18%;
  }

  .model2 {
    width: 461px;
    height: 205px;
    position: absolute;
    top: 46%;
    right: 15%;
  }

  .model3 {
    width: 642px;
    height: 158px;
    position: absolute;
    bottom: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/Mkc.vue